import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "summary", "field", "alert"]
  static values  = { active: { type: Number, default: 1 } }

  connect() {
    this.activate(this.activeValue)
    this.form = this.element.closest("form")
    if (this.form) {
      this.onSubmit = this.onSubmit.bind(this)
      this.form.addEventListener("submit", this.onSubmit, true)
    }
  }

  disconnect() {
    if (this.form && this.onSubmit) this.form.removeEventListener("submit", this.onSubmit, true)
  }

  toggle(event) {
    const step = parseInt(event.currentTarget.closest("[data-step]").dataset.step, 10)
    this.activate(step)
  }

  next(event) {
    const step = parseInt(event.currentTarget.dataset.step, 10)
    this.fillSummary(step)
    this.activate(step + 1)
  }

  activate(step) {
    this.activeValue = step
    this.stepTargets.forEach((el) => {
      const num = parseInt(el.dataset.step, 10)
      el.classList.toggle("active", num === step)
      el.classList.toggle("done",   num <  step)
    })
  }

  fillSummary(step) {
    const target = this.summaryTargets.find((el) => parseInt(el.dataset.step, 10) === step)
    if (!target) return
    const fields = this.fieldTargets.filter((el) => parseInt(el.dataset.step, 10) === step)
    const values = fields.map((el) => el.value).filter((v) => v && v.trim().length).map((v) => v.trim())
    target.textContent = values.join(" · ")
  }

  onSubmit(event) {
    const invalid = this.fieldTargets.find((el) => this.isEmpty(el))
    if (!invalid) return

    event.preventDefault()
    event.stopImmediatePropagation()

    this.fieldTargets.forEach((el) => el.classList.toggle("field_with_errors", this.isEmpty(el)))

    const step = parseInt(invalid.dataset.step, 10)
    if (!Number.isNaN(step)) this.activate(step)

    if (this.hasAlertTarget) this.alertTarget.classList.remove("hidden")

    setTimeout(() => {
      invalid.scrollIntoView({ behavior: "smooth", block: "center" })
      invalid.focus({ preventScroll: true })
    }, 380)
  }

  isEmpty(el) {
    if (el.disabled) return false
    return !el.value || !el.value.trim().length
  }
}
